<template>
    <div class="ad">
        <div class="adLeft">
            <div class="add" v-if="addList && addListFlag1">
                <router-link  :to="{path:'/jobDetail',query:{jobDetailId:addList[4][0].recruitId}}">
                    <img :src="addList[4][0].img" alt="科研人才网-高校教师硕士博士科研招聘平台">
                </router-link>
                <p @click="addListFlag1 = false">关闭</p>
            </div>
            <div  class="add" v-if="addList && addListFlag2">
                <router-link  :to="{path:'/jobDetail',query:{jobDetailId:addList[6][0].recruitId}}">
                    <img :src="addList[6][0].img" alt="科研人才网-高校教师硕士博士科研招聘平台">
                </router-link>
                <p @click="addListFlag2 = false">关闭</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'addif',
    props: {
        fiveListData: {
            // type: Object,
            // default: {}
        },
    },
    data () {
        return {
            qqFlag:false,
            telShowFlag:false,
            WeChatFlag:false,
            addList:{},
            toTopShow:true,
            scrollTop:"",
            addListFlag1:true,
            addListFlag2:true,
            addListFlag3:true,
        }
    },
    methods:{
        handleScroll() {
            let dom =document.documentElement;
            this.scrollTop = dom.scrollTop;
            if (this.scrollTop > 300) {
                this.toTopShow = true;
            }else {
                this.toTopShow = false;
            }
        },
        
    },
    mounted() {
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll,true);
        });
    },
    destroyed() {
        window.addEventListener('scroll', this.handleScroll,true);
    },
    watch:{
      fiveListData: {
          immediate: true,
          handler(val, oldval){ 
            this.addList = val;
          }
      }
    }
}
</script>
<style scoped = "scoped"  lang = "less">
.ad{
    position: fixed;
    width: 80px;
    top: 50%;
    left: 50%;
    height: 530px;
    margin-top: -265px;
    margin-left: -686px;
    .add{
        position: relative;
        p{
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 30px;
            line-height: 30px;
            background-color: #999;
            color: #fff;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            display: none;
        }
    }
    .add:hover p{
        display: block;
    }
    .adLeft{
        /* position: fixed; */
        position: absolute;
        top: 50%;
        left: 0;
        width: 80px;
        height: 530px;
        margin-top: -265px;
        img{
            width: 80px;
            height: 288px;
        }
        .add:last-child{
            img{
                height: 220px;
                margin-top: 20px;
            }
        }
    }
    .adRight{
        /* position: fixed; */
        position: absolute;
        top: 50%;
        right: 0;
        width: 80px;
        height: 530px;
        margin-top: -265px;
        img{
            width: 80px;
            height: 288px;
        }
        a:last-child{
            img{
                height: 220px;
                margin-top: 20px;
            }
        }
        .advisory{
            width: 60px;
            /* margin-top: 20px; */
            position: absolute;
            bottom: -20px;
            .adBlock{
                cursor: pointer;
                position: relative;
                width: 60px;
                height: 60px;
                color: #666;
                font-size: 12px;
                background-color: white;
                text-align: center;
                box-sizing: border-box;
                border-bottom: 1px solid #ccc;
                img{
                    width: 20px;
                    height: 20px;
                    margin-top: 10px;
                }
                div{
                    position: absolute;
                    width: 180px;
                    height: 170px;
                    right: 60px;
                    top: -60px;
                    background-color: white;
                    img{
                        width: 120px;
                        height: 120px;
                    }
                }
            }
        }
    }
}
@media all and (max-width: 1360px) {
    .adLeft{
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/addil.vue